import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { TranslationProvider } from './context/translationContext';
import { RouterContainer } from './pages/RouterContainer';

export const App = () => {
  return (
    <BrowserRouter>
      <TranslationProvider>
        <RouterContainer />
        <ToastContainer />
      </TranslationProvider>
    </BrowserRouter>
  );
};
